import { FormItem, InputProps } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { EInvoiceAddressSchemeType } from '../../enums/eInvoiceAddressSchemeType'
import { EInvoiceScheme } from '../../types/eInvoiceScheme'
import { EInvoiceAddressSchemeTypeSelect } from './elements/EInvoiceAddressSchemeTypeSelect'

interface EInvoiceAddressSchemeTypeSelectFieldProps {
  countryId?: string
  formItemColumnEnd?: number
  formItemColumnStart?: number
  handleSchemeTypeChange: (schemeType?: EInvoiceAddressSchemeType) => void
  schemeType: EInvoiceScheme
  size?: InputProps['size']
}

export const EInvoiceAddressSchemeTypeSelectField = ({
  countryId,
  formItemColumnEnd,
  formItemColumnStart,
  handleSchemeTypeChange,
  schemeType,
  size,
}: EInvoiceAddressSchemeTypeSelectFieldProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <FormItem
      itemColumnEnd={formItemColumnEnd}
      itemColumnStart={formItemColumnStart}
      label={t('customer_modal.form.e_invoice_address_format.label')}
    >
      <EInvoiceAddressSchemeTypeSelect
        countryId={countryId}
        onSelect={(_id?: string, value?: EInvoiceAddressSchemeType) => {
          handleSchemeTypeChange(value)
        }}
        placement="top-start"
        selectedId={schemeType}
        size={size}
        withSearch={false}
      />
    </FormItem>
  )
}
